export const OpeningFixedBrand = ({ bnd }) => {
  return (
    <div className="landing-page-logo-container">
      <div className="landing-page-logo">
        <img src={bnd}></img>
      </div>
    </div>
  );
};
